<template>
  <div class="card-body">
    <!-- Call to action -->
    <div class="form-row mb-2">
      <div class="col-6 d-flex align-items-center">
        <toggle-button :color="colorPrimary" :height="26" v-model="is_stolen" :sync="true" />
        <label class="font-weight-bold text-dark text-2 ml-2" @click.prevent="isStolenSwitchHandler">
          {{ trans('My vehicle is already stolen') }}
        </label>
      </div>
    </div>
    <label class="error" v-if="hasError('is_stolen')">{{ errors['is_stolen'][0] }}</label>

    <template v-if="is_stolen">
      <!-- Scene of the crime -->
      <div class="form-row align-items-baseline mt-4">
        <div class="col-12">
          <h4>{{ trans('Details of hijacking / Scene of the crime') }}</h4>
          <hr class="solid mt-0">
        </div>
      </div>

      <div class="form-row align-items-baseline">
        <!-- Street -->
        <div class="form-group required col-lg-4">
          <label :for="`${this.id}-street`" class="font-weight-bold text-dark text-2">{{ trans('Street') }}</label>
          <input :id="`${this.id}-street`"
                 type="text"
                 placeholder=""
                 v-model="streetValue"
                 class="form-control" :class="{ error: hasError('street') }">
          <label class="error" v-if="hasError('street')">{{ errors['street'][0] }}</label>
        </div>

        <!-- Place -->
        <div class="form-group required col-lg-4">
          <label :for="`${this.id}-place`" class="font-weight-bold text-dark text-2">{{ trans('Postal Code, Place') }}</label>
          <input :id="`${this.id}-place`"
                 type="text"
                 placeholder=""
                 v-model="placeValue"
                 class="form-control" :class="{ error: hasError('postal_code') }">
          <label class="error" v-if="hasError('postal_code')">{{ errors['postal_code'][0] }}</label>
        </div>
      </div>

      <div class="form-row align-items-baseline">
        <!-- Time -->
        <div class="form-group required col-lg-4">
          <label class="font-weight-bold text-dark text-2">{{ trans('Time of action') }}</label>
          <vue-ctk-date-time-picker v-model="timeFromValue"
                                    :id="`${id}-timefrom`"
                                    format="YYYY-MM-DD HH:mm:ss"
                                    :max-date="now"
                                    :button-now-translation="trans('Now')"
                                    :label="trans('Select date & time')"
                                    :color="colorPrimary"
                                    :button-color="colorPrimary" />
          <label class="error" v-if="hasError('time_from')">{{ errors['time_from'][0] }}</label>
        </div>

        <div class="form-group required col-lg-4">
          <label class="font-weight-bold text-dark text-2">{{ trans('Until') }}</label>
          <vue-ctk-date-time-picker v-model="timeToValue"
                                    :id="`${id}-timeto`"
                                    format="YYYY-MM-DD HH:mm:ss"
                                    :max-date="now"
                                    :button-now-translation="trans('Now')"
                                    :label="trans('Select date & time')"
                                    :color="colorPrimary"
                                    :button-color="colorPrimary" />
          <label class="error" v-if="hasError('time_to')">{{ errors['time_to'][0] }}</label>
        </div>

        <!-- Reward -->
        <div class="form-group col-lg-4">
          <label :for="`${this.id}-reward`" class="font-weight-bold text-dark text-2">{{ trans('Reward') }}</label>
          <input :id="`${this.id}-reward`"
                 type="text"
                 placeholder="500 €"
                 v-model="rewardValue"
                 class="form-control" :class="{ error: hasError('reward') }">
          <label class="error" v-if="hasError('reward')">{{ errors['reward'][0] }}</label>
        </div>

        <div class="form-group required col-12">
          <label class="font-weight-bold text-dark text-2">{{ trans('Description') }}</label>
          <custom-textarea :class="{ error: hasError('description') }" v-model="descriptionValue" />
          <label class="error" v-if="hasError('description')">{{ errors['description'][0] }}</label>
        </div>
      </div>

      <!-- More Details -->
      <div class="form-row align-items-baseline">
        <div class="col-12">
          <h4>{{ trans('More Details') }}</h4>
          <hr class="solid mt-0">
        </div>
      </div>

      <div class="form-row align-items-baseline">
        <!-- Police Document  -->
        <div class="form-group required col-lg-4">
          <label :for="`${this.id}-police-document`" class="font-weight-bold text-dark text-2">{{ trans('Police Document Number')}}</label>
          <input :id="`${this.id}-police-document`"
                 type="text"
                 placeholder=""
                 v-model="policeDocumentValue"
                 class="form-control" :class="{ error: hasError('police_document') }">
          <label class="error" v-if="hasError('police_document')">{{ errors['police_document'][0] }}</label>
        </div>

        <!-- Police Document  -->
        <div class="form-group required col-lg-4">
          <label :for="`${this.id}-police-department`" class="font-weight-bold text-dark text-2">{{ trans('Police Department')}}</label>
          <input :id="`${this.id}-police-department`"
                 type="text"
                 placeholder=""
                 v-model="policeDepartmentValue"
                 class="form-control" :class="{ error: hasError('police_department') }">
          <label class="error" v-if="hasError('police_department')">{{ errors['police_department'][0] }}</label>
        </div>

        <!-- Police Contact  -->
        <div class="form-group required col-lg-4">
          <label :for="`${this.id}-police-contact`" class="font-weight-bold text-dark text-2">{{ trans('Contact')}}</label>
          <input :id="`${this.id}-police-contact`"
                 type="text"
                 placeholder=""
                 v-model="policeContactValue"
                 class="form-control" :class="{ error: hasError('police_contact') }">
          <label class="error" v-if="hasError('police_contact')">{{ errors['police_contact'][0] }}</label>
        </div>

        <!-- Police Phone  -->
        <div class="form-group required col-lg-4">
          <label :for="`${this.id}-police-phone`" class="font-weight-bold text-dark text-2">{{ trans('Phone Number')}}</label>
          <input :id="`${this.id}-police-phone`"
                 type="text"
                 placeholder=""
                 v-model="policePhoneValue"
                 class="form-control" :class="{ error: hasError('police_phone') }">
          <label class="error" v-if="hasError('police_phone')">{{ errors['police_phone'][0] }}</label>
        </div>
      </div>

      <div class="form-row align-items baseline">
        <div class="col">
          <div class="alert alert-info">
            <i class="fas fa-info-circle"></i>
            <span>{{ trans('To protect your data, the following information is not publicly available') }}</span>
          </div>
        </div>
      </div>

      <!-- Insurance -->
      <div class="form-row align-items-baseline mt-4">
        <!-- Leasing Company / Lease Agreement -->
        <div class="form-group col-lg-4">
          <label :for="`${id}-leasing`" class="font-weight-bold text-dark text-2">
            {{ trans('Leasing Company / Lease Agreement') }}
          </label>
          <input :id="`${id}-leasing`"
                 type="text"
                 v-model="leasing"
                 class="form-control" :class="{ error: hasError('leasing_company') }">
          <label class="error" v-if="hasError('leasing_company')">{{ errors['leasing_company'][0] }}</label>
        </div>

        <!-- Insurance Company  -->
        <div class="form-group col-lg-4">
          <label :for="`${id}-insurance`" class="font-weight-bold text-dark text-2">
            {{ trans('Insurance Company') }}
          </label>
          <input :id="`${id}-insurance`"
                 type="text"
                 v-model="insurance"
                 class="form-control" :class="{ error: hasError('insurance_company') }">
          <label class="error" v-if="hasError('insurance_company')">{{ errors['insurance_company'][0] }}</label>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import { ToggleButton } from 'vue-js-toggle-button'
  import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
  import CustomTextarea from './VehicleTheft/CustomTextarea';

  const DESCRIPTION_MAX_LENGTH = 2000;

  export default {
    name: "VehicleTheft",

    components: {
      ToggleButton,
      VueCtkDateTimePicker,
      CustomTextarea,
    },

    props: {
      isStolen: {
        type: Boolean,
        required: false,
        default: false
      },
      street: {
        validator: prop => typeof prop === 'string' || prop === null,
        required: true,
      },
      place: {
        validator: prop => typeof prop === 'string' || prop === null,
        required: true,
      },
      timeFrom: {
        validator: prop => typeof prop === 'string' || prop === null,
        required: true,
      },
      timeTo: {
        validator: prop => typeof prop === 'string' || prop === null,
        required: true,
      },
      description: {
        validator: prop => typeof prop === 'string' || prop === null,
        required: true,
      },
      reward: {
        validator: prop => typeof prop === 'string' || prop === null,
        required: true,
      },
      policeDocument: {
        validator: prop => typeof prop === 'string' || prop === null,
        required: true,
      },
      policeDepartment: {
        validator: prop => typeof prop === 'string' || prop === null,
        required: true,
      },
      policeContact: {
        validator: prop => typeof prop === 'string' || prop === null,
        required: true,
      },
      policePhone: {
        validator: prop => typeof prop === 'string' || prop === null,
        required: true,
      },
      leasingCompany: {
        validator: prop => typeof prop === 'string' || prop === null,
        required: true,
      },
      insuranceCompany: {
        validator: prop => typeof prop === 'number' || prop === null,
        required: true,
      },
      errors: {
        validator: prop => typeof prop === 'object' || prop === null,
        required: true,
        default: {},
      }
    },

    data() {
      return {
        id: null,
        now: null,
        is_stolen: this.isStolen,

        streetValue: this.street,
        placeValue: this.place,
        timeFromValue: this.timeFrom,
        timeToValue: this.timeTo,
        descriptionValue: this.description,
        rewardValue: this.reward,
        policeDocumentValue: this.policeDocument,
        policeDepartmentValue: this.policeDepartment,
        policeContactValue: this.policeContact,
        policePhoneValue: this.policePhone,

        leasing: this.leasingCompany,
        insurance: this.insuranceCompany,
      }
    },

    watch: {
      is_stolen(val) {
        this.$emit('update:isStolen', val)
      },
      streetValue(val) {
        this.$emit('update:street', val)
      },
      placeValue(val) {
        this.$emit('update:place', val)
      },
      timeFromValue(val) {
        this.$emit('update:timeFrom', val)
      },
      timeToValue(val) {
        this.$emit('update:timeTo', val)
      },
      descriptionValue(val) {
        this.$emit('update:description', val)
      },
      rewardValue(val) {
        this.$emit('update:reward', val)
      },
      policeDocumentValue(val) {
        this.$emit('update:policeDocument', val)
      },
      policeDepartmentValue(val) {
        this.$emit('update:policeDepartment', val)
      },
      policePhoneValue(val) {
        this.$emit('update:policePhone', val)
      },
      policeContactValue(val) {
        this.$emit('update:policeContact', val)
      },
      leasing(val) {
        this.$emit('update:leasingCompany', val)
      },
      insurance(val) {
        this.$emit('update:insuranceCompany', val)
      },
    },

    mounted() {
      this.id = this.$options.name + this._uid;
      this.now = new Date().toISOString();
    },

    computed: {
      colorPrimary() {
        return '#4c8aa3';
      },

      descriptionRemaining() {
        return this.descriptionValue.length
          ? DESCRIPTION_MAX_LENGTH - this.descriptionValue.length
          : DESCRIPTION_MAX_LENGTH;
      }
    },

    methods: {
      isStolenSwitchHandler() {
        this.is_stolen = !this.is_stolen
      },

      hasError(fieldName) {
        return this.errors.hasOwnProperty(fieldName);
      }
    }
  }
</script>
